export default __webpack_public_path__ + "maps-guides-styles-layers-symbol-layer-label-960-40c4c610942fea986b52a954d98572c2.webp";